import {doClientRequest} from './core/ErplyAPI';

// eslint-disable-next-line import/prefer-default-export
export const getServiceEndpoints = () => doClientRequest({
  request: 'getServiceEndpoints'
})